export default {"src":"/_next/static/media/tw.f2c8ba78.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};